// import Error from 'components/alerts/Error'
import { Modal } from 'components/modal';
import { IModalControlItem } from 'components/modal/modules/controls/IModalControlItem';
import { closeModal } from 'components/modal/modules/dispatcher/methods';
import React from 'react';
import { Link } from 'react-router-dom';
import { fetchGraphQL } from 'services/graphql/GraphQL';

/**
 * Used to show Event Deletion Modal
 * @param eventId ID Of event
 * @param eventName Name of Event
 */
export function openDeleteEventModal(eventId: string, eventName?: string, handle?: any) {
	const modalContent = (
		<div>
			<h6>
				<br />
				Are you sure you want to delete {eventName ? eventName : ''}? <br />
				<br />
				<br />
			</h6>
			<div style={{ width: "100%" }}>
				<div className="Seperate-Buttons">

					<button
						className='new-button-white-3'
						style={{ border: 'none', cursor: 'pointer' }}
						onClick={e => Modal.Dispatch.CloseModal()}
					>
						CANCEL
					</button>

					<button
						className='new-button-white-3'
						style={{ border: 'none' }}
						onClick={e => deleteEvent()}
					>
						DELETE
					</button>
				</div>
			</div>
		</div>
	);
	const deleteEvent = () => {
		fetchGraphQL(
			`mutation {
							event {
									delete(eventId: "${eventId}")
							}
					}`,
			undefined,
			{},
		).then(result => {
			Modal.Dispatch.CloseModal();
			handle();
		});
	};
	const modalControls: IModalControlItem[] = [];
	Modal.Dispatch.OpenModal(modalContent, 'Event Deletion', modalControls);
}


/**
 * Used to show Event Deletion Modal
 *
 * @param eventId ID Of event
 * @param eventName Name of Event
 */
export function openActivateTicketModal(eventId: string, eventName?: string) {
	const modalContent = (
		<div
			className='container container-full container-centered'
			style={{ height: '100%' }}
		>
			<div className='row'>
				<div className='col-sm-12'>
					<div style={{ maxWidth: '300px', margin: '0 auto' }}>
						<Link
							to={'/manage/activate/physical/' + eventId}
							className='btn btn-primary btn-lg btn-block'
							onClick={e => closeModal()}
						>
							Printed Tickets Activation
						</Link>

						<Link
							to={'/manage/activate/digital/' + eventId}
							onClick={e => closeModal()}
							className='btn btn-primary btn-lg btn-block'
						>
							Digital Ticket Activation
						</Link>
					</div>
				</div>
			</div>
		</div>
	);

	const modalControls: IModalControlItem[] = [];

	Modal.Dispatch.OpenModal(modalContent, 'Activate Ticket', modalControls);
}



// WEBPACK FOOTER //
// ./src/components/platform/card/methods.tsx